export const tasksConstants = {
  GET_PROJECTS: "GET_PROJECTS",
  GET_TASKS: "GET_TASKS",
  GET_TAGS: "GET_TAGS",
  TASK_DETAILS: "TASK_DETAILS",
  FILTER_TASK: "FILTER_TASK",
  SEARCH_TASKS: "SEARCH_TASKS",
  SHOW_ALL: "SHOW_ALL",
  SHOW_BY_PROJECT: "SHOW_BY_PROJECT",
  SHOW_BY_STATE: "SHOW_BY_STATE",
  SHOW_BY_TAG: "SHOW_BY_TAG",
};
